import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from '@mui/material';
import React from 'react';
import { License } from '../../api/api-generated';
import { useFindAllHardwareQuery } from '../../api/api-hooks';
import { useHardwareTypeMap } from '../../hooks/useHardwareTypeMap';
import { useSoftwareTypeMap } from '../../hooks/useSoftwareTypeMap';

interface Props {
  licenses: License[];
}

const HardwareDisplayForUnlinkedLicenses = ({ licenses }: Props) => {
  const { data: allHardware } = useFindAllHardwareQuery({});
  const softwareTypeMap = useSoftwareTypeMap();
  const hardwareTypeMap = useHardwareTypeMap();
  if (allHardware === undefined || !hardwareTypeMap) return null;
  const rows: {
    serial: string;
    softwareType: string;
    unitType: string;
  }[] = [];
  for (const license of licenses) {
    if (!license.hardware.departmentId) {
      const softwareType = softwareTypeMap.get(license.softwareId);
      const unitType = hardwareTypeMap.get(license.hardware.hardwareTypeId);
      const newRow = {
        serial: license.hardware.serial,
        softwareType: softwareType ? softwareType : '',
        unitType: unitType ? unitType : '',
      };
      rows.push(newRow);
    }
  }
  const sortedRows = rows.sort((row1, row2) =>
    row1.serial.localeCompare(row2.serial)
  );
  if (sortedRows.length === 0)
    return (
      <Typography>No company licenses not linked to a department.</Typography>
    );
  return (
    <TableContainer>
      <Table size='small' aria-label='hardware table'>
        <TableHead>
          <TableRow>
            <TableCell align='right'>Serial</TableCell>
            <TableCell align='right'>Unit Type</TableCell>
            <TableCell align='right'>Software</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell align='right'>{row.serial}</TableCell>
              <TableCell align='right'>{row.unitType}</TableCell>
              <TableCell align='right'>{row.softwareType}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HardwareDisplayForUnlinkedLicenses;
